module.exports = __webpack_public_path__ + "static/sport/bgi-swiper.4b1163a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jump/bgi-swiper.png
// module id = wFuc
// module chunks = 0